import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=31aa855e&scoped=true"
import script from "./FormModal.vue?vue&type=script&lang=js"
export * from "./FormModal.vue?vue&type=script&lang=js"
import style0 from "./FormModal.vue?vue&type=style&index=0&id=31aa855e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa855e",
  null
  
)

export default component.exports